var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20002 2H3.60002V2.8H5.20002V2ZM9.20002 2H7.60002V2.8H9.20002V2ZM2.79997 2.79948H3.59997V3.59948H2.79997V2.79948ZM2.8 3.60026H2V6.00026H2.79997V6.8H3.59997V6H2.8V3.60026ZM4.40002 6.79948H3.60002V7.59948H4.40002V6.79948ZM4.39998 7.60026H5.19998V8.40026H4.39998V7.60026ZM6.00003 8.39974H5.20003V9.19974H6.00003V8.39974ZM6 9.20052H6.8V10.0005H6V9.20052ZM7.59997 8.39974H6.79997V9.19974H7.59997V8.39974ZM7.60002 7.60026H8.40002V8.40026H7.60002V7.60026ZM9.19998 6.79948H8.39998V7.59948H9.19998V6.79948ZM10 6.00026H10.8V3.60026H10V6H9.20003V6.8H10V6.00026ZM5.20003 2.79948H6.00003V3.59948H5.20003V2.79948ZM6.8 3.60026H6V4.40026H6.8V3.60026ZM6.79997 2.79948H7.59997V3.59948H6.79997V2.79948ZM10 2.79948H9.20003V3.59948H10V2.79948Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartS);
export default __webpack_public_path__ + "static/media/heart-s.479781ef7b760845535369747b070d22.svg";
export { ForwardRef as ReactComponent };